<app-admin-header style="width: 100%;" [header]="header" [links]="links" [breadcrumbs]="breadcrumbs"
    [stats]="[]"></app-admin-header>
<div class="w-100">
    <app-skelitions [hidden]="!skelition" [value]="2" class="mb-2"></app-skelitions>
</div>
<!-- <section class="container-fluid ms-main-bg py-5"> -->
<div  *ngIf="!skelition"  class="container ms-pg-structure my-5">

  <div class="d-flex-between-mob-column">
    <div>
      <h4 class="large-h main-heading">{{"Visit Calander" | translator}}</h4>
    </div>
    <div>
      <app-project-step [step]="'Calander'" [projectId]="projectID"></app-project-step>
    </div>
  </div>
  <app-project-details-card *ngIf="basicChannels && project && !skelition" [project]="project"
            [channels]="basicChannels" [branches]="selectedBranchesProject"></app-project-details-card>
  <p-messages [(value)]="messages" [enableService]="false"></p-messages>

  <div class="white-box">
    <div class="d-flex justify-content-center">
      <div class="max-width-1400">
        <p-dropdown [options]="sessions" [(ngModel)]="sessionID" optionValue="_id" appendTo="body"
          (onChange)="onSessionChange()"
          [placeholder]="'Select a session' | translator">
          <ng-template let-item pTemplate="selectedItem">
            {{ item.name }} -- {{ item.startDate |date}} -- {{item.endDate | date}}
          </ng-template>
          <ng-template let-item pTemplate="item">
            {{ item.name }} -- {{ item.startDate |date}} -- {{item.endDate | date}}
          </ng-template>
        </p-dropdown>
        
        <div class="d-flex justify-content-between align-items-center">
          <button class="ms-btn-onclick my-2" (click)="prevMonth()"><b>{{'Previous Month' | translator}}</b></button>
          <h2 class="my-2 t-main-b">{{ formatMonthAndYear() }}</h2>
          <button class="ms-btn-onclick my-2" (click)="nextMonth()"><b>{{'Next Month' | translator }}</b></button>
        </div>
        <div class="d-flex justify-content-start flex-wrap">
          <div class="calender-day-box" *ngFor="let day of daysOfWeek">{{ day | translator }}</div>
        </div>
        <div class="d-flex justify-content-start flex-wrap my-3">
          <div *ngFor="let week of calendarData" class="d-flex justify-content-start flex-wrap">
            <div *ngFor="let dayData of week" [ngClass]="{'negative-day': dayData._id.day <= 0}"
              (click)="validateDayData(dayData)" class="calender-number-box">
              <div class="calender-postition-number" [hidden]="dayData._id.day<=0">{{ dayData._id.day }}</div>
              <div class="ms-flex-column">
                <div class="calender-training-topic" *ngFor="let training of dayData.data">
                  <i *ngIf="!(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) && (statusType == '' || statusType == 'Redo' || statusType == 'Change')" class="fa fa-trash s-5 text-danger" (click)="DeleteVisit($event,training)"></i>
                  {{ training?.visits?.data?.channel?.name }}
                  ({{training?.visits?.data?.time}})
                  <br>
                  {{ (training?.visits?.data?.branch?.name) ? '( '+ training?.visits?.data?.branch?.name + " - (" + training?.visits?.data?.branch?.details?.location?.name +') )' : '' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) && (statusType == '' || statusType == 'Redo' || statusType == 'Change')" class="d-flex justify-content-end gap-1">
      <button class="next-btn" (click)="submitForApproval()" >{{'SubmitMS' | translator}}</button>
    </div>
  </div>

  <ng-container *ngIf="(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) && statusType == 'Pending'">
    <div class="my-4 bg-comment-color mx-1">
        <h5 class="medium-h p-3">{{'Comments' | translator}}</h5>
        <input class="ms-input-textarea" type="textarea" 
            [(ngModel)]="pmComment" placeholder="">
    </div>
    <div class="d-flex justify-content-center gap-1">
        <button (click)="redoStatus()" class="re-do-btn mx-2">{{'Redo' | translator}} <i
          class="fa-solid fa-arrows-rotate mx-2"></i></button>
        <button (click)="approveStatus()" class="next-btn">{{'Approve' | translator}} <i
          class="pi pi-check-circle mx-2"></i></button>
    </div>
</ng-container>
<ng-container *ngIf="statusType != '' ">
    <div class="my-4 bg-comment-color mx-1" align="center">
        <h5 class="medium-h p-3" [ngClass]=" statusType == 'Approved' ? 'text-success' : (statusType == 'Change' ? '' : (statusType == 'Pending' ? '' : 'text-danger'))">
          <ng-container *ngIf="statusType === 'Change' || statusType === 'Pending'; else defaultTemplate">
              {{ 'Visit Calander' | translator }} {{ ('are in ' + statusType + ' State') | translator }}
          </ng-container>
          <ng-template #defaultTemplate>
            {{ ('are in ' + statusType + ' State') | translator }} {{ (statusType == 'Approved') ?  ('Visit Calander' | translator) : '' }}
          </ng-template>
        </h5>
        <h5 *ngIf="statusType == 'Redo' || statusType == 'Change'" class="medium-h p-3">{{ pmComment }}</h5>
    </div>
</ng-container>
<ng-container *ngIf="(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) && statusType == 'Approved'">
  <div class="my-4 bg-comment-color mx-1">
      <h5 class="medium-h p-3">{{'Comments' | translator}}</h5>
      <input class="ms-input-textarea" type="textarea" 
          [(ngModel)]="pmComment" placeholder="">
  </div>
  <div class="d-flex justify-content-center gap-1">
      <button (click)="requestChange()" class="next-btn">{{'Request Change' | translator}}</button>
  </div>
</ng-container>
<div class="d-flex justify-content-between">
  <button [routerLink]="'/ms/factor/'+ projectID"  class="next-btn">{{'Back' | translator}} <i
          class="pi pi-arrow-right mx-2"></i></button>
  <button *ngIf="statusType == 'Approved' && evaluationEnabled" [routerLink]="'/ms/evaluation/' + projectID" class="next-btn">{{'Next' | translator}} <i
          class="pi pi-arrow-left mx-2"></i></button>
</div>
</div>


<p-dialog header="{{'Add Visit'|translator}}" [(visible)]="showDilogue" [modal]="true"
  [style]="{ width: '40vw' , maxWidth:'1000px' }" [draggable]="false" [resizable]="false">
  <ng-template pTemplate="body">
    <div class="d-flex flex-column w-100 gap-3 align-items-start justify-content-center timer-v4-bg col-12">
    <label>
      {{'date' | translator}} : {{modalData?._id?.month}} / {{modalData?._id?.day}} / {{modalData?._id?.year }}
    </label>
      <p-dropdown class="w-100 w-full 1111" [options]="channels" [(ngModel)]="selectChanel" optionLabel="name" appendTo="body"
        [placeholder]="'Select Channel' | translator"></p-dropdown>
      <p-dropdown class="w-100 w-full 2222" *ngIf="hasBranches && selectChanel && selectChanel.name == 'Branches'" [options]="selectedBranches" [(ngModel)]="selectBranch" optionLabel="name" appendTo="body"
        [placeholder]="'Select Branch' | translator"></p-dropdown>
      <input class="timer-v4" [(ngModel)]="selectedTime" appendTo="body" type="time">

    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button [hidden]="!this.selectChanel || !selectedTime" (click)="addVisit()"
      [label]="'Submit'|translator"></p-button>
  </ng-template>
</p-dialog>
<p-confirmDialog [style]="{margin: '0rem 1rem'}"></p-confirmDialog>
<app-footer></app-footer>